import Swiper from 'swiper';
import { Grid } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/grid';

const MOBILE_MAX_WIDTH = 990;

// Храним инстансы, чтобы не создавать по несколько раз на один и тот же контейнер
const sliderInstances = new WeakMap();

function createSlider(slider) {
    if (sliderInstances.has(slider)) return;

    const swiper = new Swiper(slider, {
        modules: [Grid],
        slidesPerView: 1,
        spaceBetween: 10,
        grid: {
            rows: 2,
            fill: 'row',
        },
        slidesPerColumnFill: 'row',
        breakpoints: {
            360: {
                slidesPerView: 2,
                grid: {
                    rows: 2,
                    fill: 'row',
                },
                slidesPerColumnFill: 'row',
            },
            640: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                    fill: 'row',
                },
                slidesPerColumnFill: 'row',
            },
        },
    });

    sliderInstances.set(slider, swiper);
}

function destroySlider(slider) {
    const instance = sliderInstances.get(slider);
    if (!instance) return;

    instance.destroy(true, true);
    sliderInstances.delete(slider);
}

function updateSliders() {
    const sliders = document.querySelectorAll('.section-menu__swiper');
    if (!sliders.length) return;

    const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;

    sliders.forEach((slider) => {
        if (isMobile) {
            createSlider(slider);
        } else {
            destroySlider(slider);
        }
    });
}

// Простая "ручная" дебаунс-функция, чтобы не дёргать Swiper на каждый пиксель
let resizeTimeout = null;
function onResize() {
    if (resizeTimeout) {
        clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(() => {
        updateSliders();
    }, 150);
}

document.addEventListener('DOMContentLoaded', updateSliders);
window.addEventListener('resize', onResize);
